"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefineModalButton = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const refine_modal_button_style_1 = require("./refine-modal-button.style");
const refine_modal_component_1 = require("./refine-modal.component");
const RefineModalButton = ({ activeColumns, columns, defaultColumns, setActiveColumns, children, disabled, }) => {
    const [isOpen, setOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(refine_modal_component_1.RefineModal, { activeColumns: activeColumns, columns: columns, defaultColumns: defaultColumns, isOpen: isOpen, setActiveColumns: setActiveColumns, setOpen: setOpen }), react_1.default.createElement(refine_modal_button_style_1.StyledButtonRefine, null, react_1.default.createElement(ui_components_1.Button, { disabled: disabled, variant: 'outlined', onClick: () => setOpen(true) }, children))));
};
exports.RefineModalButton = RefineModalButton;
exports.default = react_1.default.memo(exports.RefineModalButton);
